import React from 'react';
import styles from './styles.module.scss';

const EditButton = ({ onHandleClick, isHidden }) => (
  <a onClick={onHandleClick} className={styles.editButton} hidden={isHidden}>EDIT<img src='/assets/icon_edit.png' /></a>
)

export default EditButton;